import React, { forwardRef, Ref, HTMLAttributes } from "react";

export interface ReactProps {
  class?: string;
  className?: string;
  style?: { [key: string]: any };
}

export type ReactExternalProps<PropType, ElementType> = PropType &
  Omit<HTMLAttributes<ElementType>, "style"> &
  ReactProps;

export const createForwardRef = <PropType, ElementType>(
  ReactComponent: any,
  displayName: string
) => {
  const forwardRefFunction = (
    props: ReactExternalProps<PropType, ElementType>,
    ref: Ref<ElementType>
  ) => <ReactComponent {...props} forwardedRef={ref} />;
  forwardRefFunction.displayName = displayName;

  return forwardRef(forwardRefFunction);
};
